import { Text } from "@chakra-ui/react";

export const StatusCell = (children: React.ReactNode) => {
    return (
        <Text
            padding="2px 8px"
            borderRadius="9999px"
            bgColor="#3b82f6"
            textAlign="center"
            color="white"
            w="100%"
            fontSize="12px"
            fontWeight={600}
            lineHeight="16px"
        >
            {children}
        </Text>
    );
};